/* eslint-disable */
<template>
  <v-container style="max-width: 1600px !important">
    <!-- <p
      class="font-weight-bold text-xs-center pt-5"
      style="font-size: 36px !important; margin-bottom: 10px"
    >TESTIMONIALS</p> -->
    <v-layout
      class="pb-5"
      align-center
      justify-center
      row
      wrap>

      <!-- Carousel Component -->
      <v-flex
        d-flex
        xs12
        md8>
        <div class="mx-3">

          <v-carousel
            :hide-controls="responsive"
            class="elevation-0"
            interval="10000"
            height="380"
            max="1000"
            hide-delimiters
            dark
          >
            <v-carousel-item
              v-for="(testimonial,i) in testimonials"
              :key="i">
              <div class="testimonial-box">
                <i class="fas fa-quote-left fa2"/>
                <div class="text">
                  <i class="fas fa-quote-right fa1"/>
                  <div style="margin-top: -20px">
                    <h3 class="font-weight-bold">{{ testimonial.company }}</h3>
                    <p
                      class="font-italic"
                      style="color: #e5e5e5 !important"
                    >{{ testimonial.testimony }}</p>
                    <h5 style="display: inline">{{ testimonial.name }}</h5>
                    <h6
                      class="hidden-sm-and-down"
                      style="color: #e5e5e5 !important; display: inline; text-transform: none !important; margin-left: 5px"
                    >{{ testimonial.occupation }}</h6>
                    <h6
                      class="hidden-md-and-up"
                      style="color: #e5e5e5 !important; text-transform: none !important;"
                    >{{ testimonial.occupation }}</h6>
                  </div>
                </div>
              </div>
            </v-carousel-item>
          </v-carousel>
        </div>
      </v-flex>

      <!-- Client Satisfaction -->
      <v-flex
        xs12
        md4>
        <div class="mx-3  px-3">
          <div class="testimonial-content-right">
            <p
              style="font-size: 24px !important; padding-bottom: 10px;"
              class="font-weight-medium"
            >Client satisfaction</p>
            <p
              class="mb-4"
              style="color: #4f5d75 !important; font-size: 15px !important; font-weight: 300; text-align: left;"
            >We have produce multiple projects according to our clients requests and we have yet to let them down.</p>
            <p
              class="mb-4"
              style="color: #4f5d75; font-size: 15px !important; font-weight: 300; text-align: left;"
            >Why just believe what we say. Take some time and view our portfolio collection to help you better asses your potential goal getters. Trust us, we wont disappoint.</p>
            <v-btn
              :to="{path: 'portfolio'}"
              style="display: block; margin: 50px auto 0;"
              color="#2a2a2a"
              round
              dark
            >See Our Portfolio</v-btn>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    responsive: false,
    testimonials: [
      {
        company: 'Aliform Marketing & Event',
        name: 'Mc Ng',
        testimony:
          'Young passionate team that thrives to be the best. And what can I say. They have impressed me so far.',
        occupation: 'General Manager'
      },
      {
        company: 'CAH Management',
        name: 'Sheng Lee',
        testimony:
          'We gave them requirements and they produce a website better than what we first expected. Plus it was delivered before the promised date of delivery.',
        occupation: 'Cheif Executive Officer'
      }
    ]
  }),
  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },

  methods: {
    onResponsiveInverted () {
      if (window.innerWidth < 720) {
        this.responsive = true
      } else {
        this.responsive = false
      }
    }
  }
}
</script>

<style>
.v-btn .v-btn__content .v-icon {
  color: #2a2a2a !important;
}

.testimonial-content-right {
  max-width: 420px;
}
@media (max-width: 960px) {
  .testimonial-content-right {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
}

/* the layout for the testimonial box slider */
.testimonial-box {
  background-color: transparent;
  border-radius: 3px;
  color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  height: 350px;
  transform-style: preserve-3d;
  perspective: 2000px;
  transition: 0.4s;
  text-align: center;
}

/* Readjusting the size of the box based on viewport */
@media (min-width: 961px) and (max-width: 1170px) {
  .testimonial-box {
    width: 420px;
  }
}

@media (min-width: 720px) and (max-width: 960px) {
  .testimonial-box {
    width: 510px;
  }
}

@media (max-width: 719px) {
  .testimonial-box {
    width: 85%;
  }
}

/* css for the text in the slider box */
.testimonial-box .text {
  position: absolute;
  top: 30px;
  left: -30px;
  width: calc(100% + 60px);
  height: calc(100% - 60px);
  background-color: #2a2a2a;
  border-radius: 3px;
  transition: 0.4s;
}

/* css for the div in the slider box */
.testimonial-box .text div {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  text-align: center;
  width: 100%;
  padding: 30px 60px;
  line-height: 1.5;
  box-sizing: border-box;
}

.testimonial-box .text div h3 {
  font-size: 30px;
  margin-bottom: 5px;
}

.testimonial-box .text div p {
  font-size: 16px !important;
}
@media (max-width: 559px) {
  .testimonial-box .text div p {
    font-size: 13px !important;
  }
  .testimonial-box .text div h3 {
    font-size: 18px !important;
  }

}
</style>
